export const calcChange = (current: number, previous: number) => {
  if (previous === 0)
    return {
      change: current > 0 ? 100 : 0,
      direction: current > 0 ? 'positive' : 'neutral',
    };

  const change = Number((((current - previous) / previous) * 100).toFixed(2));
  const direction =
    change > 0 ? 'positive' : change < 0 ? 'negative' : 'neutral';

  return { change, direction };
};
